import ObjectTableController from "./object_table_controller"

export default class ExchangeMarketTopicRecordsObjectTableController extends ObjectTableController {
  static values = {
    ...ObjectTableController.values,
    subjectType: "asset",
    parentSubjectType: "market",
    enableEdit: false,
    isFavouriteEnabled: false,
  }
}
